import { render } from "./TermAssuranceExpressQuestion.vue?vue&type=template&id=789193c8&scoped=true"
import script from "./TermAssuranceExpressQuestion.vue?vue&type=script&lang=js"
export * from "./TermAssuranceExpressQuestion.vue?vue&type=script&lang=js"

import "./TermAssuranceExpressQuestion.vue?vue&type=style&index=0&id=789193c8&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789193c8"]])

export default __exports__